export default "__VITE_ASSET__6b2286c6__"